import * as yup from 'yup';
import { DiscountBanner } from '@web/molecules';

export const component = DiscountBanner;

export const schema = yup
  .object({
    sticky: yup.bool(),
    promoMessage: yup.string(),
    linkText: yup.string(),
    bgColor: yup.string(),
    fontColor: yup.string(),
    typography: yup.string(),
    verticalPadding: yup.number(),
    horizontalPadding: yup.number(),
  })
  .transform(value => ({
    sticky: value.sticky,
    promoMessage: value.promo_message,
    linkText: value.link_text,
    typography: value.typography,
    verticalPadding:
      value.vertical_padding === '' || isNaN(Number(value.vertical_padding))
        ? undefined
        : Number(value.vertical_padding),
    horizontalPadding:
      value.horizontal_padding === '' || isNaN(Number(value.horizontal_padding))
        ? undefined
        : Number(value.horizontal_padding),
    bgColor: value.background_color || undefined,
    fontColor: value.font_color || undefined,
  }));
